$(document).ready(function () {
    $("#reset").click(function () {
        window.location.href = "/index.html";
    });

    $(".navUl li a").each(function () {
        $this = $(this);
        if ($this[0].href == String(window.location)) {
            $(".navUl li").removeClass("activer");
            $this.parent().addClass("activer"); //active表示被选中效果的类名   
        }
    });

    //    $(".nav_header>ul>li.click_me").click(function () {
    //        $(".nav_header>ul>li.click_me").removeClass("activer");
    //        $(this).addClass("activer");
    //        let content=$(this).text().trim();
    //        if(content=='亿橙科技'){
    //         window.location.href="/index.html";
    //            console.log('亿橙科技')

    //         //    $("#one").addClass("activer")
    //         //    $("#two").addClass("")
    //         //    $("#three").addClass("")
    //         //    $("#four").addClass("")
    //         //    $("#five").addClass("")

    //        }else if(content=='产品'){
    //            window.location.href="/page/demandCustomization.html";
    //        }else if(content=='应用'){
    //            window.location.href="/page/application.html";
    //        }else if(content=='关于亿橙科技'){
    //         console.log('关于亿橙科技')
    //         window.location.href="/page/aboutYicheng.html";      
    //         //    $("#one").addClass("")
    //         //    $("#two").addClass("")
    //         //    $("#three").addClass("")
    //         //    $("#four").addClass("")
    //            $("#five").addClass("activer")
    //        }
    //    })
    $(".nav_header>ul>li").mouseover(function () {
        if ($(this).text() == '核心技术底层') {
            $(".nav_pull").show();
        }
        if ($(this).text() == '产品') {
            $(".nav_pull_pro").show();
        }
        if ($(this).text() == '案例') {
            $(".nav_pull_case").show();
        }
    }).mouseout(function () {
        if ($(this).text() == '核心技术底层') {
            $(".nav_pull").hide();
        }
        if ($(this).text() == '产品') {
            $(".nav_pull_pro").hide();
        }
        if ($(this).text() == '案例') {
            $(".nav_pull_case").hide();
        }
    });
    $(".nav_pull").mouseover(function () {
        $(".nav_pull").show();
    }).mouseout(function () {
        $(".nav_pull").hide();
    });

    $(".nav_pull_pro").mouseover(function () {
        $(".nav_pull_pro").show();
    }).mouseout(function () {
        $(".nav_pull_pro").hide();
    });

    $(".nav_pull_case").mouseover(function () {
        $(".nav_pull_case").show();
    }).mouseout(function () {
        $(".nav_pull_case").hide();
    });

    // $(".nav_pull>p>span:nth-of-type(2)").click(function(){
    //     let content=$(this).text();
    //     if(content=='亿橙大数据分析平台'){
    //         window.location.href="/page/coreProduct/product_big.html";
    //     }else if(content=='亿橙NLP智能分析平台'){
    //         window.location.href="/page/coreProduct/Literature_manager.html";
    //     }
    //     // else if(content=='亿橙智能数字化加工平台'){
    //     //     window.location.href="/page/coreProduct/digital_process.html"; 
    //     // }
    // })
    $(".nav_pull>p>span:nth-of-type(2)>a").each(function () {
        $this = $(this);
        if ($this[0].href == String(window.location)) {
            $(".navUl li").removeClass("activer");
            $("#two").addClass("activer"); //active表示被选中效果的类名   
        }
    });

    // $(".nav_pull_pro>p>span:nth-of-type(2)").click(function(){
    //     let content=$(this).text();
    //     if(content=='数据安全智能监测系列'){
    //         window.location.href="/page/coreProduct/product.html";
    //     }else if(content=='情报文献挖掘管理系列'){
    //         window.location.href="/page/coreProduct/documentInformation.html";
    //     }
    //     else if(content=='系列产品'){
    //         window.location.href="/page/application.html"; 
    //     }
    // })

    $(".nav_pull_pro>p>span:nth-of-type(2)>a").each(function () {
        $this = $(this);
        if ($this[0].href == String(window.location)) {
            $("#two").removeClass("activer");
            $(".navUl li").removeClass("activer");
            $("#three").addClass("activer"); //active表示被选中效果的类名   
        }
    });

    // $(".nav_pull_case>p>span:nth-of-type(2)").click(function(){
    //     let content=$(this).text();
    //     if(content=='数据安全'){
    //         window.location.href="/page/coreProduct/dataSecurity.html";
    //     }else if(content=='大数据平台'){
    //         window.location.href="/page/coreProduct/bigDataPlatform.html";
    //     }
    //     else if(content=='情报文献'){
    //         window.location.href="/page/coreProduct/literature.html"; 
    //     }
    // })

    $(".nav_pull_case>p>span:nth-of-type(2)>a").each(function () {
        $this = $(this);
        if ($this[0].href == String(window.location)) {
            $("#three").removeClass("activer");
            $(".navUl li").removeClass("activer");
            $("#four").addClass("activer"); //active表示被选中效果的类名   
        }
    });
});